<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <div class="tw-px-[26px]">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-gap-[10px]">
          <button
            @click="
              () => {
                if (activeSelectRowsMultiple.length) {
                  nextModalFromPin = 'acceptBank';
                  $modal.show('pincode');
                } else {
                  $toast.error('Выберите хотя-бы одно поле');
                }
              }
            "
            class="tw-app-btn-primary-outline"
          >
            {{ dataLang["register_bor_text_1"] }}
          </button>
          <button
            @click="
              () => {
                if (activeSelectRowsMultiple.length) {
                  nextModalFromPin = 'rejectBank';
                  $modal.show('pincode');
                } else {
                  $toast.error('Выберите хотя-бы одно поле');
                }
              }
            "
            class="tw-app-btn-primary-outline"
          >
            {{ dataLang["register_bor_text_2"] }}
          </button>
        </div>
        <div class="tw-text-[12px]">
          <span class="tw-text-forText">
            {{ dataLang["register_bor_text_3"] }}:
          </span>
          {{ dataTable.length }}
        </div>
      </div>

      <div class="tw-flex tw-justify-between tw-mt-[15px]">
        <div class="tw-flex">
          <button @click="loadData()" class="tw-app-btn-primary-outline">
            {{ dataLang["register_btn_filter_on"] }}
          </button>

          <button
            @click="resetFilter()"
            class="tw-app-btn-light !tw-text-[#0056AF]"
          >
            Сбросить
          </button>
        </div>
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationFinesStateParams,
            limit: limitPaginationValue,
          }"
          :showLimitInput="true"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div>

      <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
        <BaseLoader v-if="localLoading" style="z-index: 100"></BaseLoader>
        <ve-table
          class="rest-style-table fixed-header"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="balance_out_requests__id"
          ref="mainTable"
          :cell-style-option="cellStyleOption"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :clickHighlight="false"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>
    <!-- <SendNotificationModal />
    <AddBalanceFirstStepModal />
    <AddBalanceSecondStepModal />
    <DoneAddModal />
    <ConsumptionBalanceFirstStepModal />
    <DoneСonsumptionModal />
    <ConsumptionBalanceSecondStepModal />
    <CompaniesModal />
    <ConsumptionBalanceTreeStepModal />
    <ConsumptionBalanceFourStepModal /> -->

    <BaseModal
      name="pincode"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('pincode')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('pincode')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="acceptNext"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="moneyBackRejectBankModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('moneyBackRejectBankModal')"
        ></button>

        <div class="">
          <div class="tw-app-modal__title">
            {{ dataLang["register_bor_text_26"] }}
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["register_bor_text_27"] }}
            </div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder=""
              :width="'360'"
              class="mb-15"
              :input-name="'messageForReject'"
              @input="(data) => (messageForReject = data.value)"
            />
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('moneyBackRejectBankModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="onSendRejectAndMessage"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["register_bor_text_29"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="moneyBackAcceptBankModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="
        () => (copyActiveSelectRowsMultiple = activeSelectRowsMultiple)
      "
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('moneyBackAcceptBankModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["register_bor_text_14"] }}
          </div>

          <div class="tw-mb-[15px]" v-html="textForModal"></div>

          <div>{{ dataLang["register_bor_text_16"] }}</div>

          <div class="tw-mb-[15px] tw-text-forText tw-text-[12px]">
            {{ dataLang["register_bor_text_17"] }}
          </div>

          <div class="tw-mb-[15px]">
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder=""
              :width="'360'"
              class="mb-5"
              :placeholder="dataLang['register_bor_text_18']"
              :input-name="'messageForReject'"
              @input="(data) => (lastBillNumber = data.value)"
            />
          </div>

          <div class="tw-mb-[15px]">{{ dataLang["register_bor_text_19"] }}</div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('moneyBackAcceptBankModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="onSendAcceptAndDoc"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["register_bor_text_21"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="moneyBackDoneModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('moneyBackDoneModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["register_bor_text_22"] }}
          </div>

          <div
            v-html="dataLang['register_bor_text_23']"
          ></div>

          <div
            class="tw-mb-[15px]"
            v-html="dataLang['register_bor_text_24']"
          ></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('moneyBackDoneModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="onDoneAccept"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["register_bor_text_25"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
// import SendNotificationModal from './companies-modal/SendNotificationModal.vue'
// import DoneAddModal from './companies-modal/DoneAddModal.vue'
// import DoneСonsumptionModal from './companies-modal/DoneСonsumptionModal.vue'
// import AddBalanceFirstStepModal from './companies-modal/add-balance/AddBalanceFirstStepModal.vue'
// import ConsumptionBalanceFirstStepModal from './companies-modal/consumption-balance/ConsumptionBalanceFirstStepModal.vue'
// import ConsumptionBalanceSecondStepModal from './companies-modal/consumption-balance/ConsumptionBalanceSecondStepModal.vue'
// import AddBalanceSecondStepModal from './companies-modal/add-balance/AddBalanceSecondStepModal.vue'
// import ConsumptionBalanceTreeStepModal from './companies-modal/consumption-balance/ConsumptionBalanceTreeStepModal.vue'
// import ConsumptionBalanceFourStepModal from './companies-modal/consumption-balance/ConsumptionBalanceFourStepModal.vue'

import CompaniesModal from "./companies-modal/CompaniesModal.vue";
import EventBus from "@/event-bus";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    // SendNotificationModal,
    // CompaniesModal,
    // DoneAddModal,
    // ConsumptionBalanceFirstStepModal,
    // DoneСonsumptionModal,
    // AddBalanceFirstStepModal,
    // AddBalanceSecondStepModal,
    // ConsumptionBalanceSecondStepModal,
    // ConsumptionBalanceTreeStepModal,
    // ConsumptionBalanceFourStepModal
  },

  data() {
    return {
      limitPaginationValue: 50,
      typePin: "",
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      copyActiveSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      activePagePagination: {},
      pincode: "",
      messageForReject: "",
      nextModalFromPin: "",
      documentId: "",
      textForModal: "",
      lastBillNumber: "",
      dataForModal: {},
      selectsData: {},
      selectsFilter: {},
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "companies__status") {
            return row?.config?.companies__status;
          }
          if (column.field == "companies__last_activity_at") {
            return row?.config?.companies__last_activity_at;
          }
          if (column.field == "companies__balance") {
            return row?.config?.companies__balance;
          }
        },
      },
    };
  },
  methods: {
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    async onLoadDoc(data) {
      try {
        let dataFrom = await httpInstance.get(
          `/download/bank/${data.documentId}`,
          {
            responseType: "blob",
          }
        );
        console.log(dataFrom);
        const filename = new Date().toISOString();
        const url = window.URL.createObjectURL(dataFrom.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.txt`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (e) {
        console.error(e);
      }
    },

    onDoneAccept() {
      if (this.documentId.length) {
        GeneralService.editOrCreate(
          `/balance_out_requests/accept/step3/${this.activeSelectRowsMultiple}?pincode=${this.pincode}`,
          { documentId: this.documentId }
        )
          .then((data) => {
            this.nextModalFromPin = "";
            this.$modal.hide("moneyBackDoneModal");
            this.$toast.success(data.data.message);
            this.activeSelectRowsMultiple = [];
            this.documentId = "";
            this.nextModalFromPin = "";
            this.messageForReject = "";
            this.loadData();
          })
          .catch((e) => {
            this.$toast.error(e?.response?.data.message, { duration: 5000 });
          });
      }
    },

    onSendAcceptAndDoc() {
      if (this.lastBillNumber.length) {
        GeneralService.editOrCreate(
          `/balance_out_requests/accept/step2/${this.activeSelectRowsMultiple}?pincode=${this.pincode}`,
          { lastBillNumber: this.lastBillNumber }
        )
          .then((data) => {
            this.nextModalFromPin = "";
            this.$modal.hide("moneyBackAcceptBankModal");
            this.$modal.show("moneyBackDoneModal");
            this.$toast.success(data.data.message);
            this.documentId = data.data.data.documentId;
            this.onLoadDoc({ documentId: data.data.data.documentId });
          })
          .catch((e) => {
            this.$toast.error(e?.response?.data.message, { duration: 5000 });
          });
      }
    },

    onSendRejectAndMessage() {
      if (this.messageForReject.length) {
        GeneralService.delete(
          `/balance_out_requests/reject/${this.activeSelectRowsMultiple}`,
          {},
          {
            data: {
              comment: this.messageForReject,
            },
          }
        )
          .then((data) => {
            this.nextModalFromPin = "";
            this.messageForReject = "";
            this.$modal.hide("moneyBackRejectBankModal");
            this.$toast.success(data.data.message);
            this.loadData();
          })
          .catch((e) => {
            this.$toast.error(e?.response?.data.message, { duration: 5000 });
          });
      }
    },

    acceptNext() {
      if (this.pincode.length) {
        GeneralService.get(
          `/settings?fields=company_settings__set_security_pass_for_forbidden`
        )
          .then((data) => {
            if (
              this.pincode ==
              data.data.data.rows[0]
                .company_settings__set_security_pass_for_forbidden
            ) {
              if (this.nextModalFromPin == "acceptBank") {
                GeneralService.editOrCreate(
                  `/balance_out_requests/accept/step1/${this.activeSelectRowsMultiple}?pincode=${this.pincode}`
                )
                  .then((data) => {
                    console.log(data.data.data);

                    this.textForModal = this.computedTranslate(
                      data.data.data,
                      this.dataLang["register_bor_text_15"]
                    );
                    this.$modal.show("moneyBackAcceptBankModal");
                  })
                  .catch((e) => {});
              }
              if (this.nextModalFromPin == "rejectBank") {
                this.$modal.show("moneyBackRejectBankModal");
              }

              this.$modal.hide("pincode");
            } else {
              this.$toast.error("Некоррентный пинкод", { duration: 5000 });
            }
          })
          .catch((e) => {
            this.$toast.error(e?.response?.data.message, { duration: 5000 });
          });
      }
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    saveEditModal() {
      GeneralService.edit(`/trackers/${this.dataForModal.gps__id}`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.$modal.hide("editTracker");
          this.loadData();
        })
        .catch((e) => {
          this.selectsFromModal.owners = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.loadData();
    },

    onCloseModal() {},
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },

    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/cities`)
          .then((data) => {
            this.selectsData.city = data.data.data.rows;
          })
          .catch((e) => {
            console.error(e);
          }),
      ]).then(() => {
        GeneralService.get(`/balance_out_requests/table/main`, {
          params: {
            page: page,
            limit: this.limitPaginationValue,
            where: JSON.stringify([...this.filter]),
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.getFinesAll(data.data.data);
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      console.log(data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        let indexed = this.filter.findIndex((x) => x.field == data.name);
        this.filter[indexed].value = newValueFilter;
        if (data?.operator) {
          this.filter[indexed].operator = data.operator;
        }
      }
      let indexed = this.filter.findIndex((x) => x.field == data.name);
      if (indexed !== -1) {
        this.filter[indexed].value = newValueFilter;
        if (data.type == "delete") {
          console.log(323323223);
          this.filter.splice(indexed, 1);
        }
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateContentData", () => {
      this.loadData();
    });
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "1%",
          align: "center",
        },
        {
          field: "balance_out_requests__created_at",
          key: "1623236",
          title: this.dataLang["register_bor_text_4"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.balance_out_requests__created_at
                  ? this.$time(row.balance_out_requests__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companies__id",
          key: "162336",
          title: this.dataLang["register_bor_text_30"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div style={"height: 20px"}></div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"companies__id"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "companies__created_at",
          key: "12861326",
          title: this.dataLang["register_bor_text_5"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__created_at
                  ? this.$time(row.companies__created_at).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companies__name",
          key: "16336",
          title: this.dataLang["register_bor_text_31"],
          align: "center",
          width: "20%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div style={"height: 20px"}></div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"companies__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "employees__name",
          key: "1363326",
          title: this.dataLang["register_bor_text_6"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "employees__phone",
          key: "136326",
          title: this.dataLang["register_bor_text_7"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_settings__set_req_rs",
          key: "162136",
          title: this.dataLang["register_bor_text_8"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_settings__set_req_bank",
          key: "172551",
          title: this.dataLang["register_bor_text_9"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_settings__set_req_bik",
          key: "166136",
          title: this.dataLang["register_bor_text_10"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__balance",
          key: "1286136",
          title: this.dataLang["register_bor_text_12"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                {row.companies__balance
                  ? row.companies__balance.split(".").join(",")
                  : ""}
              </div>
            );
          },
        },
        {
          field: "balance_out_requests__amount",
          key: "12846136",
          title: this.dataLang["register_bor_text_13"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                {row.balance_out_requests__amount
                  ? row.balance_out_requests__amount.split(".").join(",")
                  : ""}
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.payload-button {
  display: flex;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;

  &--consumption {
    border-radius: 3px;
    box-shadow: 0px 7px 2px 0px #00000000;
    background-color: rgb(223, 222, 222);

    &:before {
      content: "";
      background-color: #ff2400;
      width: 7px;
      height: 1.5px;
      display: block;
      margin: auto;
    }
  }

  &--move {
    background-color: #0c63aa;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }

  &--top {
    background-color: #8000ff;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }

  &--add {
    background-color: #f6ee25;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }
}

.top-line-custom {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: white;
  width: 65%;
}
</style>
